//#region Imports 
import React, { useEffect, useState } from 'react';
import { StyleSheet, SafeAreaView, View, Platform, FlatList } from 'react-native';
import { useRoute } from '@react-navigation/native';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@react-navigation/native';
import CustomLabel from '../../components/CustomLabel/CustomLabel';
import CustomButton from '../../components/CustomButton/CustomButton';
import MySurveys from '../SelfService/Surveys/MySurveys';
import MySurveysAdmin from '../SelfService/Surveys/MySurveysAdmin';
import CreateSurvey from '../SelfService/Surveys/CreateSurvey';
import ResultsSurvey from '../SelfService/Surveys/ResultsSurvey';
import EditSurvey from '../SelfService/Surveys/EditSurvey';
import ResponseScreen from '../SelfService/Surveys/ResponseScreen';
import { loadEverySurvey, loadEverySurveyForUser, deleteSurvey } from "../../services/SurveyService";
import { useAuthContext } from '../../hooks/useAuthContext';
import { useAccountContext } from '../../hooks/useAccountContext';
import RoleGuard from '../../components/RoleGuard';
import { TASKS, TASK_OPTIONS } from '../../constants/Tasks';
//#endregion

const HomePageSurveys = () => {
  //#region const definitions
  const { t } = useTranslation();
  const { user, clientApi } = useAuthContext();
  const route = useRoute();
  const { account } = useAccountContext();
  const { colors } = useTheme()
  const styles = makeStyles(colors);
  const [showMySurveys, setShowMySurveys] = useState(0)
  const [showSurveysAdmin, setShowSurveysAdmin] = useState(0)
  const [showResponseScreen, setShowResponseScreen] = useState(0)
  const [showCreateScreen, setShowCreateScreen] = useState(0)
  const [showEditScreen, setShowEditScreen] = useState(0)
  const [showResultsScreen, setShowResultsScreen] = useState(0)
  const [DeleteSurvey, setDeleteSurvey] = useState(0)
  const [responseSurveyId, setResponseSurveyId] = useState('');
  const buttonTable = [1, 2, 3, 4, 5, 6, 7, 8]
  const [surveyList, setSurveyList] = useState([])
  const [userSurveyList, setUserSurveyList] = useState([])
  //#endregion

  //#region API Call 
  const load = () => {
    loadEverySurvey(clientApi, user.token)
      .then(respSurveys => {
        setSurveyList(respSurveys)
        loadEverySurveyForUser(clientApi, user.token, account.employeeId).then(respUserSurveys => {
          setUserSurveyList(respUserSurveys)
        }).catch(innerError => console.error(innerError))
      })
      .catch(error => {
        console.error(error)
      });
  }
  //#endregion


  const handleDelete = (surveyid) => {
    deleteSurvey(clientApi, surveyid, user.token)
      .then(() => {
        let filtereddata = surveyList.filter(item => item.id !== surveyid)
        setSurveyList(filtereddata)
        setDeleteSurvey(0);
      })
      .catch(error => {
        console.error(error)
      });
  }

  //#region UseEffects
  useEffect(() => {
    load();
  }, [showSurveysAdmin])


  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      try {
        localStorage.setItem('isRefresh', "true");
        localStorage.setItem('lastVisitedScreen', 'HomePageSurveys');
      } catch (error) {
        console.log(error.message);
      };
    };
    if (Platform.OS === 'web') {
      window.addEventListener('beforeunload', handleBeforeUnload);
      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
      };
    };
  }, []);

  useEffect(() => {
    load();
    if (!route.params?.surveyId) setShowMySurveys(1);
  }, []);

  useEffect(() => {
    if (route.params?.surveyId) {
      setResponseSurveyId(route.params.surveyId);
      setShowMySurveys(0);
      setShowResponseScreen(1);
    }
  }, [route.params?.surveyId]);
  //#endregion

  return (
    <SafeAreaView style={[styles.main]}>
      {/* SubMenu */}
      <View>
        <FlatList
          horizontal
          showsHorizontalScrollIndicator={true}
          directionalLockEnabled={true}
          alwaysBounceVertical={false}
          data={buttonTable}
          contentContainerStyle={{ alignSelf: 'flex-start', marginBottom: '1%' }}
          showsVerticalScrollIndicator={false}
          renderItem={({ index }) => {
            return (
              <SafeAreaView>
                {index == 1 && Platform.OS === 'web' &&
                  <RoleGuard task={TASKS.UTILSADMIN} requireCRUD>
                    <CustomButton
                      onPress={() => {
                        setShowSurveysAdmin(1);
                        setShowMySurveys(0);
                        setShowResponseScreen(0);
                        setShowResultsScreen(0);
                        setShowCreateScreen(0);
                        setShowEditScreen(0);
                        setDeleteSurvey(0);
                      }}
                      text={t('common:surveyAdmin')}
                      iconName='clipboard-outline'
                      show={showSurveysAdmin ? 'HOME_SELECTED' : 'HOME'}
                      type={showSurveysAdmin ? 'HOME_SELECTED' : 'HOME'}
                      textTop='0'
                      isGradient={showSurveysAdmin ? true : false}
                      sz={25}
                    />
                  </RoleGuard>
                }
                {/* //! Admin survey on the legacy system was added on HR side. But now migrated to SS. No Task option for now due to time constrains  */}
                {index == 2 &&
                  <RoleGuard parentTask={TASKS.ALLEMPLOYEETASKS} task={TASK_OPTIONS.SURVEYS} requireCRUD>
                    <CustomButton
                      onPress={() => {
                        setShowSurveysAdmin(0);
                        setShowMySurveys(1);
                        setShowResponseScreen(0);
                        setShowResultsScreen(0);
                        setShowCreateScreen(0);
                        setShowEditScreen(0);
                        setDeleteSurvey(0);
                      }}
                      text={t('common:survey')}
                      iconName='newspaper-outline'
                      show={showMySurveys ? 'HOME_SELECTED' : 'HOME'}
                      type={showMySurveys ? 'HOME_SELECTED' : 'HOME'}
                      textTop='0'
                      sz={25}
                      isGradient={showMySurveys ? true : false}
                    />
                  </RoleGuard>}
              </SafeAreaView>
            )
          }}
          keyExtractor={item => `${item}`}
        />
      </View>

      {/* // * My Surveys Screen */}
      {showMySurveys ?
        <SafeAreaView style={[styles.submain]}>
          <CustomLabel
            value={t('common:survey')}
            type='MINORTITLE'
          />
          <MySurveys
            data={userSurveyList}
            loadEverySurvey={loadEverySurvey}
            setShowResponseScreen={setShowResponseScreen}
            setShowMySurveys={setShowMySurveys}
            setResponseSurveyId={setResponseSurveyId}
          />
        </SafeAreaView> : <></>
      }

      {/* // * Response Screen */}
      {showResponseScreen ?
        <SafeAreaView
          style={styles.submain}>
          <CustomLabel
            value={t('common:surveyResponse')}
            type='MINORTITLE'
          />
          <ResponseScreen
            survId={responseSurveyId}
            setShowEditScreen={setShowEditScreen}
            setShowResponseScreen={setShowResponseScreen}
            setShowCreateScreen={setShowCreateScreen}
            setShowMySurveys={setShowMySurveys}
            setShowSurveysAdmin={setShowSurveysAdmin} />
        </SafeAreaView> : <></>}

      {/* //* Create Survey Screen */}
      {showCreateScreen ?
        <SafeAreaView
          style={styles.submain}>
          <CustomLabel
            value={t('common:surveyCreate')}
            type='MINORTITLE'
          />
          <CreateSurvey
            setShowResponseScreen={setShowResponseScreen}
            setShowEditScreen={setShowEditScreen}
            setShowCreateScreen={setShowCreateScreen}
            setShowMySurveys={setShowMySurveys}
            setShowSurveysAdmin={setShowSurveysAdmin} />
        </SafeAreaView> : <></>}

      {/* //* Edit Survey Screen */}
      {showEditScreen ?
        <SafeAreaView
          style={styles.submain}>
          <CustomLabel
            value={t('common:surveyEdit')}
            type='MINORTITLE'
          />
          <EditSurvey
            survId={responseSurveyId}
            setShowResponseScreen={setShowResponseScreen}
            setShowMySurveys={setShowMySurveys}
            setShowEditScreen={setShowEditScreen}
            setShowCreateScreen={setShowCreateScreen}
            setShowSurveysAdmin={setShowSurveysAdmin} />
        </SafeAreaView> : <></>
      }

      {DeleteSurvey ?
        handleDelete(responseSurveyId) : null
      }

      {/* Results Screen  */}
      {showResultsScreen ?
        <SafeAreaView
          style={styles.submain}>
          <CustomLabel
            value={t('common:surveyResults')}
            type='MINORTITLE'
          />
          <ResultsSurvey
            survId={responseSurveyId}
            setShowResponseScreen={setShowResponseScreen}
            setShowMySurveys={setShowMySurveys}
            setShowEditScreen={setShowEditScreen}
            setShowCreateScreen={setShowCreateScreen}
            setShowSurveysAdmin={setShowSurveysAdmin} />
        </SafeAreaView> : <></>
      }

      {/* Survey Admin Screen */}
      {showSurveysAdmin ?
        <SafeAreaView style={[styles.submain]}>
          <CustomLabel
            value={t('common:surveyAdmin')}
            type='MINORTITLE'
          />
          <MySurveysAdmin
            data={surveyList}
            loadEverySurvey={loadEverySurvey}
            setShowMySurveys={setShowMySurveys}
            setResponseSurveyId={setResponseSurveyId}
            setShowResponseScreen={setShowResponseScreen}
            setShowSurveysAdmin={setShowSurveysAdmin}
            setShowCreateScreen={setShowCreateScreen}
            setShowEditScreen={setShowEditScreen}
            setShowResultsScreen={setShowResultsScreen}
            setDeleteSurvey={setDeleteSurvey}
          />
        </SafeAreaView> : <></>
      }
    </SafeAreaView>
  );
}


const makeStyles = (colors, width) => StyleSheet.create({
  main: {
    flex: 1,
    marginTop: '1%',
    marginHorizontal: 10
  },
  submain: {
    flex: 1,
    backgroundColor: colors.background,
  },

  scrollMain: {
    backgroundColor: 'transparent'
  },
  item: {
  },
  row: {
    flex: 1,
    flexDirection: "row"
  },

});

export default HomePageSurveys; 